import { FlexColumn, FormControls } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { Controller, UseFormReturn } from 'react-hook-form';
import OwnersChipListAutocomplete from 'shared/components/OwnersChipListAutocomplete';
import TagsChipListAutocomplete from 'shared/components/TagsChipListAutocomplete';
import { AddTestForm } from 'shared/types';

type Props = {
  methods: UseFormReturn<AddTestForm, any, undefined>;
};

const TestMetadataForm = ({ methods }: Props) => (
  <FormControls.FieldsWrapper>
    <FormControls.TestAccordion
      variant="secondary"
      summary={
        <Typography sx={{ fontWeight: 'bold' }}>Test metadata</Typography>
      }
    >
      <FlexColumn>
        <FormControls.Row>
          <FormControls.FormText>Owners:</FormControls.FormText>
          <Controller
            name="owners"
            control={methods.control}
            render={({ field }) => <OwnersChipListAutocomplete {...field} />}
          />
        </FormControls.Row>
        <FormControls.Row>
          <FormControls.FormText>Tags:</FormControls.FormText>
          <Controller
            name="tags"
            control={methods.control}
            render={({ field }) => <TagsChipListAutocomplete {...field} />}
          />
        </FormControls.Row>
      </FlexColumn>
    </FormControls.TestAccordion>
  </FormControls.FieldsWrapper>
);

export default TestMetadataForm;
